import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { LOGOUT, getCurrentUser } from "data-handler/ducks/auth";
import { useSelector } from "react-redux";

import { clearLocalStorage } from "helpers/utils";

/**
 * Logs out, redirects to root, renders `null`
 */
export default () => {
  const currentUser = useSelector(getCurrentUser);
  const dispatch = useDispatch();
  const isAdmin = currentUser?.is_admin;

  useEffect(() => {
    if (isAdmin) {
      clearLocalStorage();
    }
    dispatch({ type: LOGOUT });
  }, [dispatch, isAdmin]);

  return null;
};
